import isEmpty from 'lodash/isEmpty';
import { getWirCGOrganiseKOM } from 'pages/WellGuardian/WIR/utils';
import {
  WIRCreatedSections,
  WIRCreateJourneyStepsKeys,
  WIRStageGate2Sections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { useCallback, useMemo } from 'react';
import { useCountryState, useSelectedWIR } from '../../../../redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { CountryData, WIR, WIRPhaseTypes } from 'types/wellGuardian';

import { getKickOffPhaseName, getWirCreatedPhaseName } from '../utils/getSectionData';

export const useSectionOrganiseKickOffMeetingData = () => {
  const wirFromState = useSelectedWIR();
  const countryState = useCountryState();

  const organiseKickOffMeetingPayload = useMemo(() => {
    const { phase, organiseKickOffMeeting } = getWirCGOrganiseKOM(wirFromState, countryState);
    const meetingDate = organiseKickOffMeeting?.meetingDate ?? new Date().toISOString();
    const userIdInterventionEngineer = organiseKickOffMeeting?.userIdInterventionEngineer;
    const userNameInterventionEngineer = organiseKickOffMeeting?.userNameInterventionEngineer;
    const kickOffMeetingAttendees = organiseKickOffMeeting?.kickOffMeetingAttendees ?? [];

    const isTicked =
      !isEmpty(meetingDate) &&
      !isEmpty(userIdInterventionEngineer) &&
      !isEmpty(userNameInterventionEngineer) &&
      !isEmpty(kickOffMeetingAttendees);

    return {
      isTicked,
      meetingDate,
      userIdInterventionEngineer,
      userNameInterventionEngineer,
      kickOffMeetingAttendees,
      lastUpdatedDate: new Date().toISOString(),
      sectionCompleteConfirmation: organiseKickOffMeeting?.sectionCompleteConfirmation,
      assignedTo: organiseKickOffMeeting?.assignedTo || '',
      phase:
        countryState === CountryData.congo
          ? WIRCreateJourneyStepsKeys.CG_KICK_OFF_TECHNICAL_WIR
          : phase,
    };
  }, [wirFromState, countryState]);

  const saveOrganiseKickOffMeetingSection = useCallback(
    async (section: string, processSaveResponse: (wirResponse: WIR | null) => void) => {
      const phaseName =
        countryState === CountryData.congo
          ? getKickOffPhaseName(countryState)
          : getWirCreatedPhaseName(countryState);
      if (
        wirFromState?.wirNumber &&
        (section === WIRCreatedSections.organiseKickOffMeeting ||
          section === WIRStageGate2Sections.organiseKickOffMeeting)
      ) {
        processSaveResponse(
          await wellGuardianApiClient.updateWIROrganiseKickOffMeeting(
            wirFromState?.wirNumber,
            organiseKickOffMeetingPayload,
            organiseKickOffMeetingPayload.phase === WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
              ? WIRPhaseTypes.REACTIVE_SCOPE
              : phaseName,
            countryState,
          ),
        );
      }
    },
    [wirFromState, organiseKickOffMeetingPayload, countryState],
  );

  return {
    saveOrganiseKickOffMeetingSection,
    organiseKickOffMeetingPayload,
  };
};
